import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { formatCurrency } from '../components/FormattedCurrency';
import { Button, Flex, H1, Text } from '@urbaninfrastructure/react-ui-kit';
import { Receipt as ReceiptIcon } from '@urbaninfrastructure/react-icons';
import { useSystem } from '../lib/core/useSystem';
import { iconSize } from '../lib/constants';

export const PayRegistrationFeeStep = ({ goNext }: { goNext: () => void }) => {
  const system = useSystem();
  const intl = useIntl();
  if (!system) {
    throw new Error('System not found');
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      maxWidth="500px"
      textAlign="center"
    >
      <ReceiptIcon size={iconSize} color="primaryIcon" mb={6} />
      <H1 typoStyle="lg">
        <FormattedMessage
          id="modules.Receipt.RegistrationFee.subHeading"
          defaultMessage="Registration fee"
        />
      </H1>
      <Text mb={42}>
        <FormattedMessage
          id="registration_fee_description"
          defaultMessage={
            'To maintain and improve the service, {cityName} administration enforces a registration fee {cost} for all new users.'
          }
          values={{
            cityName: system.cityName,
            cost: formatCurrency({
              value: system.registrationFeeAmount,
              intl
            })
          }}
        />
      </Text>
      <Button shape="cool" variant="primary" onClick={() => goNext()}>
        {' '}
        <Text>
          <FormattedMessage id="i_understand" defaultMessage="I understand" />
        </Text>
      </Button>
    </Flex>
  );
};
